'use client';

export { default } from './StepLabel';
export { default as stepLabelClasses } from './stepLabelClasses';
export * from './stepLabelClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/StepLabel/index.js
// module id = 580
// module chunks = 25